import { some } from 'lodash';
import { useEffect, useState } from 'react';
import { FormStep, Package, StepType, StepTypeWithIndex } from '../../types';
import { StepNavigator } from './StepNavigator';

export const useStepNavigation = (
  rateCode: string,
  packageData: Package | undefined,
  allFormSteps: FormStep[]
) => {
  const [currentStep, setCurrentStep] = useState<StepTypeWithIndex>({
    type: 'rooms',
    index: 0,
    step: 'guestDetailsStep',
  });
  const steps: StepType[] = ['rooms'];
  if (some(packageData?.experiences)) {
    steps.push('spa');
  }
  if (some(packageData?.restaurants)) {
    steps.push('dining');
  }

  useEffect(() => {
    const currentStepHashes = allFormSteps.map((opt) => `#${opt.step}`);

    return () => {
      if (currentStepHashes.includes(window.location.hash)) {
        return;
      }
      const { pathname, search } = window.location;
      window.history.replaceState(null, '', `${pathname}${search}`);
    };
  }, [currentStep]);

  const isLastStep = currentStep.index === allFormSteps.length - 1;

  const currentFormStep = allFormSteps[currentStep.index] || allFormSteps[0];

  const goToNextStep = () => {
    setCurrentStep((val) => {
      const nextStep = allFormSteps[currentStep.index + 1];
      return nextStep
        ? { type: nextStep.type as StepType, index: val.index + 1, step: nextStep.step }
        : {
            type: 'rooms',
            index: 0,
            step: 'guestDetailsStep',
          };
    });
  };

  const goToPreviousStep = () => {
    setCurrentStep((val) => {
      const previousStep = allFormSteps[val.index - 1];

      return previousStep
        ? { type: previousStep.type as StepType, index: val.index - 1, step: previousStep.step }
        : val;
    });
  };

  return {
    stepNavigatorComponent: StepNavigator(
      rateCode,
      currentStep,
      setCurrentStep,
      steps,
      allFormSteps
    ),
    goToNextStep,
    goToPreviousStep,
    isLastStep,
    currentFormStep,
    currentStepIndex: currentStep.index,
  };
};
